export default __webpack_public_path__ + "static/media/SolarSystem_13.65df0954.png";